import TextInput from '../components/TextInput';
import Typography from '../components/Typography';
import Layout from '../components/Layout';
import { useNavigate } from '@reach/router';

const CameraIcon = ({ size = 80, onClick, className = '' }) => {
  // Image asset from Figma (valid for 7 days)
  const imgIcon =
    'https://www.figma.com/api/mcp/asset/54f41df8-7be1-47c5-a98d-435fa56baa47';

  return (
    <div
      className={`bg-[#f9fafb] border-2 border-[#d1d5db] border-dashed content-stretch flex items-center justify-center p-[2px] relative rounded-[9999px] ${className}`}
      style={{ width: `${size}px`, height: `${size}px` }}
      data-name="Button"
      data-node-id="953:33341"
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={(e) => {
        if (onClick && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div
        className="relative shrink-0"
        data-name="Container"
        data-node-id="953:33342"
      >
        <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex flex-col items-start py-[2px] relative">
          <div className="flex items-center justify-center relative shrink-0">
            <div className="-scale-y-100 flex-none">
              <div
                className="relative size-[36px]"
                data-name="Icon"
                data-node-id="953:33343"
              >
                <img
                  alt="Camera"
                  className="block max-w-none size-full"
                  src={imgIcon}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const TermsCheckbox = ({
  checked = false,
  onChange,
  onTermsClick,
  onPrivacyClick,
  className = '',
}) => {
  return (
    <div
      className={`content-stretch flex items-start relative w-full ${className}`}
      data-name="Container"
      data-node-id="953:33366"
    >
      {/* Checkbox */}
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="bg-white border border-[#d1d5db] border-solid !rounded-full shrink-0 size-[15px] cursor-pointer"
        data-name="Input"
        data-node-id="953:33368"
      />

      {/* Label Text */}
      <div
        className="content-stretch flex flex-col items-start pl-[12px] relative shrink-0"
        data-name="Margin"
        data-node-id="953:33369"
      >
        <div
          className="content-stretch flex items-start relative shrink-0 flex-wrap gap-x-1"
          data-name="Label"
          data-node-id="953:33370"
        >
          <Typography
            weight="medium"
            className="text-[14px] text-[rgba(12,35,64,0.7)] whitespace-nowrap leading-[20px]"
            data-node-id="953:33371"
          >
            I agree to the{' '}
          </Typography>
          <Typography
            weight="medium"
            color="orange"
            className="text-[14px] whitespace-nowrap leading-[20px] underline"
          >
            Terms of Service
          </Typography>
          <Typography
            weight="medium"
            className="text-[14px] text-[rgba(12,35,64,0.7)] whitespace-nowrap leading-[20px]"
            data-node-id="953:33371"
          >
            and
          </Typography>
          <Typography
            weight="medium"
            color="orange"
            className="text-[14px] whitespace-nowrap leading-[20px] underline"
          >
            Privacy Policy
          </Typography>
        </div>
      </div>
    </div>
  );
};

const CreateAccount = () => {
  const navigate = useNavigate();
  return (
    <Layout className="px-6 pt-2">
      <Typography weight="bold" className="mb-3 text-[24px] text-center">
        Create your Cauze account
      </Typography>
      <Typography color="secondary" className="mb-6 text-[14px] text-center">
        Join 100k+ givers. One account for all your charitable giving.
      </Typography>
      <CameraIcon className="mb-4 mx-auto" />
      <Typography className="mb-8 text-center" color="orange">
        Add Photo
      </Typography>
      <TextInput label="Name" required className="mb-5" />
      <TextInput label="Email" required className="mb-5" />
      <TextInput label="Password" required className="mb-5" />
      <TermsCheckbox className="mb-5" />
      <button
        className="cz-btn-brand w-full"
        onClick={() => navigate(`/gift-redeem/scan`)}
      >
        Create Account & Continue
      </button>
    </Layout>
  );
};

export default CreateAccount;
